"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.to-string");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _vuex = require("vuex");
var _blExchangeAppointmentSh = require("@/api/blExchangeAppointment/blExchangeAppointmentSh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "notificationDialog",
  components: {
    dragDialog: _DragDialog.default
  },
  data: function data() {
    return {
      count: 10,
      buttonText: this.$t('blExchangeAppointment.acknowledged'),
      buttonDisabled: false,
      timer: null
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    this.countTime();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    countTime: function countTime() {
      var _this = this;
      this.timer = setInterval(function () {
        if (_this.count <= 0) {
          _this.buttonDisabled = false;
          _this.count = 10;
          _this.buttonText = _this.$t('blExchangeAppointment.acknowledged');
          clearInterval(_this.timer);
        } else {
          _this.buttonText = _this.count.toString();
          _this.count--;
          _this.buttonDisabled = true;
        }
      }, 1000);
    },
    opened: function opened() {
      this.$nextTick(function () {});
    },
    downLoadDangerousGoodsDeclaration: function downLoadDangerousGoodsDeclaration() {
      (0, _blExchangeAppointmentSh.downLoadDangerousGoodsDeclaration)().then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res], {
          type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }));
        var link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', '告客户书-关于进口危化品集装箱申报的通知.docx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    }
  }
};